module.exports = __webpack_public_path__ + "img/twitter-black.e4088f43.svg";